// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"48d5f8ae","43":"a987d322","46":"af3bbe7a","238":"b1c563ee","453":"1826ebbf","488":"95b5ccbf","637":"9eebbec9","727":"8e456c8b","853":"fc292853","996":"e5d9aaf2"}[chunkId] + ".chunk.js";
};